import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './design-system/tokens.css';
import { ThemeProvider } from '@mui/material/styles';
import { criarTemaTeraBlues } from './design-system/temaTeraBlues';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TitleContextProvider } from './context/TitleContext';
import { DataAtualDMYContextProvider } from './context/DataAtualDMYContext';
import { LoadingContextProvider } from './context/LoadingContext';

const temaTeraBlues = criarTemaTeraBlues('light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
   <ThemeProvider theme={temaTeraBlues}>
   <LoadingContextProvider>
    <TitleContextProvider> 
      <DataAtualDMYContextProvider> 
        <App/>
      </DataAtualDMYContextProvider> 
    </TitleContextProvider> 
   </LoadingContextProvider>
   </ThemeProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
